import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Server, Zap, Shield, Globe, Monitor, FileText, Heart, Clock, ChevronLeft, ChevronRight } from 'lucide-react';
import { getStorageUrl } from '../utils/imageUrlUpdater';

const VPSVietnam: React.FC = () => {
  const [activeTab, setActiveTab] = useState('nvme');
  const [currentFeedbackSlide, setCurrentFeedbackSlide] = useState(0);
  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);


  // Set page title and canonical URL
  useEffect(() => {
    document.title = 'VPS Việt Nam - VMon Cloud';
    
    // Set canonical URL
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = 'https://vmon.vn/vps-viet-nam';
    document.head.appendChild(canonical);
    
    return () => {
      if (canonical.parentNode) {
        canonical.parentNode.removeChild(canonical);
      }
      document.title = 'VMon Cloud - Dịch vụ VPS và Hosting chất lượng cao';
    };
  }, []);

  const nvmePlans = [
    {
      name: 'VPS Basic',
      price: '115,000',
      originalPrice: '149,000',
      cpu: '1 Core',
      ram: '1GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Standard',
      price: '155,000',
      originalPrice: '299,000',
      cpu: '1 Core',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'VPS Premium',
      price: '175,000',
      originalPrice: '599,000',
      cpu: '2 Cores',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Enterprise',
      price: '315,000',
      originalPrice: '1,199,000',
      cpu: '2 Cores',
      ram: '4GB',
      storage: '60GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Pro',
      price: '575,000',
      originalPrice: '1,199,000',
      cpu: '4 Cores',
      ram: '8GB',
      storage: '100GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Advanced',
      price: '775,000',
      originalPrice: '1,199,000',
      cpu: '8 Cores',
      ram: '8GB',
      storage: '100GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Elite',
      price: '915,000',
      originalPrice: '1,199,000',
      cpu: '8 Cores',
      ram: '16GB',
      storage: '180GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Ultimate',
      price: '1,815,000',
      originalPrice: '1,199,000',
      cpu: '16 Cores',
      ram: '32GB',
      storage: '260GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    }
  ];

  const platinumPlans = [
    {
      name: 'VPS Basic',
      price: '135,000',
      originalPrice: '149,000',
      cpu: '1 Core',
      ram: '1GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Standard',
      price: '195,000',
      originalPrice: '299,000',
      cpu: '1 Core',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'VPS Premium',
      price: '255,000',
      originalPrice: '599,000',
      cpu: '2 Cores',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Enterprise',
      price: '390,000',
      originalPrice: '1,199,000',
      cpu: '2 Cores',
      ram: '4GB',
      storage: '60GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Pro',
      price: '655,000',
      originalPrice: '1,199,000',
      cpu: '4 Cores',
      ram: '8GB',
      storage: '100GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Advanced',
      price: '945,000',
      originalPrice: '1,199,000',
      cpu: '8 Cores',
      ram: '8GB',
      storage: '100GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Elite',
      price: '1,435,000',
      originalPrice: '1,199,000',
      cpu: '8 Cores',
      ram: '16GB',
      storage: '180GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Ultimate',
      price: '2,325,000',
      originalPrice: '1,199,000',
      cpu: '16 Cores',
      ram: '32GB',
      storage: '260GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'VPS Extreme',
      price: '4,185,000',
      originalPrice: '1,199,000',
      cpu: '32 Cores',
      ram: '64GB',
      storage: '480GB SSD NVMe',
      bandwidth: 'Unlimited',
      features: ['CentOS/Ubuntu', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    }
  ];

  const additionalPricing = [
    { item: '1 IP', price: '50.000 VNĐ / Tháng' },
    { item: '1 VCpu', price: activeTab === 'nvme' ? '50.000 VNĐ / Tháng' : '70.000 VNĐ / Tháng' },
    { item: '1 GB Ram', price: activeTab === 'nvme' ? '50.000 VNĐ / Tháng' : '70.000 VNĐ / Tháng' },
    { item: '10GB ổ cứng SSD NVMe', price: activeTab === 'nvme' ? '30.000 VNĐ / Tháng' : '40.000 VNĐ / Tháng' }
  ];

  const comparisonTable = [
    { feature: 'Cloud VPS', nvme: true, platinum: true },
    { feature: 'CPU E5 V4', nvme: true, platinum: false },
    { feature: 'CPU Xeon Gold', nvme: false, platinum: true },
    { feature: 'Ổ Cứng NVMe U.2', nvme: true, platinum: true },
    { feature: 'VNC Console', nvme: true, platinum: true },
    { feature: 'Firewall', nvme: false, platinum: true },
    { feature: '1Gbps Ethernet Port', nvme: true, platinum: false },
    { feature: '10Gbps Ethernet Port', nvme: false, platinum: true },
    { feature: 'IPv4', nvme: true, platinum: true },
    { feature: 'IPv6', nvme: false, platinum: true },
    { feature: 'Snapshots', nvme: false, platinum: true },
    { feature: 'Miễn Phí Backup Hàng Tuần', nvme: true, platinum: true }
  ];

  const operatingSystems = [
    { name: 'Windows', logo: getStorageUrl('/windows.svg') },
    { name: 'Ubuntu', logo: getStorageUrl('/ubuntulogo.svg') },
    { name: 'Centos', logo: getStorageUrl('/centos_color_logo.svg') },
    { name: 'AlmaLinux', logo: getStorageUrl('/almalinux_icon_logo.svg') },
    { name: 'Rocky Linux', logo: getStorageUrl('/rocky_linux_logo.svg') }
  ];

  const benefits = [
    {
      icon: Server,
      title: 'HẠ TẦNG HIỆN ĐẠI',
      description: 'Hiện nay, VPS Việt Nam tại VMon Cloud có máy chủ đặt tại 2 trung tâm dữ liệu tại thành phố lớn là Viettel Hà Nội và FPT Tp. Hồ Chí Minh.'
    },
    {
      icon: Shield,
      title: '100% Ổ CỨNG NVME U2',
      description: 'Ổ cứng NVMe đọc/ghi dữ liệu với tốc độ vài GB/s, nhanh hơn gấp nhiều lần HDD và SSD SATA. Lựa chọn lý tưởng cho các ứng dụng có nhu cầu đọc/ghi nhiều hay truy vấn database liên tục, các website nặng, game server.'
    },
    {
      icon: Zap,
      title: 'BĂNG THÔNG KHÔNG GIỚI HẠN',
      description: 'Cloud VPS Việt Nam có băng thông lên tới 1Gbps không giới hạn. Máy chủ luôn đạt thời gian hoạt động(Uptime) lên tới 99,9%.'
    },
    {
      icon: Monitor,
      title: 'ĐA DẠNG HỆ ĐIỀU HÀNH',
      description: 'VPS Việt Nam tại VMon Cloud hỗ trợ đa dạng hệ điều hành như CentOS, Ubuntu Server, Rocky, AlmaLinux, Windows 10, Windows Server 2012r2, 2016, 2019, 2022. Ngoài ra VMon Cloud còn hỗ trợ cài đặt hệ điều hành custom.'
    },
    {
      icon: Clock,
      title: 'SAO LƯU TỰ ĐỘNG HÀNG TUẦN',
      description: 'Bạn có thể hoàn toàn yên tâm về dữ liệu của mình, VMon Cloud sẽ giúp bạn backup(sao lưu) hàng tuần.'
    },
    {
      icon: FileText,
      title: 'NÂNG CẤP LINH HOẠT',
      description: 'Trang quản lý hiện đại với đầy đủ chức năng giúp bạn tự thao tác nâng cấp CPU/RAM chỉ trong vài phút, hạn chế tối đa ảnh hưởng đến hệ thống.'
    }
  ];

  const advantages = [
    {
      icon: Server,
      title: 'HOÀN TOÀN TỰ ĐỘNG',
      description: 'Hệ thống tự động được VMon Cloud phát triển giúp bạn có thể dễ dàng mua và quản lý VPS Việt Nam của mình. Khi mua VPS, khoảng từ 3-5 phút hệ thống sẽ tự động gửi thông tin VPS vào email mà bạn đã đăng ký với VMon Cloud.'
    },
    {
      icon: Heart,
      title: 'Cam Kết Hoàn Tiền',
      description: 'Trong 7 ngày đầu, bạn mua và sử dụng VPS Việt Nam thấy không hài lòng vì bất cứ lý do gì, VMon Cloud xin hoàn lại 100% tiền cho bạn.'
    },
    {
      icon: Zap,
      title: 'TIẾT KIỆM CHI PHÍ',
      description: 'VMon Cloud cung cấp các gói VPS Việt Nam với cấu hình khác nhau có giá cả phù hợp với khả năng tài chính và nhu cầu sử dụng của mỗi người.'
    },
    {
      icon: Clock,
      title: 'HỖ TRỢ TẬN TÂM 24/7',
      description: 'VMon Cloud hỗ trợ bạn ở tất cả các kênh phổ biến như Facebook, Zalo, Telegram, hoặc hotline 0966.805.315'
    }
  ];

  const feedbackImages = [
    getStorageUrl('/feedback/feedback_1.jpg'),
    getStorageUrl('/feedback/feedback_2.jpg'),
    getStorageUrl('/feedback/feedback_3.jpg'),
    getStorageUrl('/feedback/feedback_4.jpg'),
    getStorageUrl('/feedback/feedback_5.jpg'),
    getStorageUrl('/feedback/feedback12.jpg'),
    getStorageUrl('/feedback/feedback16.jpg'),
    getStorageUrl('/feedback/feedback17.jpg')
  ];

  const galleryImages = [
    {
      src: getStorageUrl('/panel/Giam-Sat-VPS.PNG'),
      title: 'Giám Sát VPS',
      description: 'Theo Dõi VPS Một Cách Thuận Tiện Từ CPU, RAM, Disk, Network.'
    },
    {
      src: getStorageUrl('/panel/Mua-VPS.PNG'),
      title: 'MUA VPS',
      description: 'Mua VPS thuận tiện với giao diện one click.'
    },
    {
      src: getStorageUrl('/panel/giao-dien-mobile.PNG'),
      title: 'Quản lý vps trên điện thoại',
      description: 'Quản lý vps trên điện thoại thuận tiện, dễ sử dụng.'
    },
    {
      src: getStorageUrl('/panel/lich-su-so-du.PNG'),
      title: 'Số Dư Tài Khoản',
      description: 'Quản lý số dư tài khoản thuận tiện và minh bạch.'
    },
    {
      src: getStorageUrl('/panel/danh-sach-vps.PNG'),
      title: 'Danh Sách VPS',
      description: 'Xem danh sách VPS một cách thuận tiện, đầy đủ thông tin.'
    },
    {
      src: getStorageUrl('/panel/cai-lai-he-dieu-hanh.PNG'),
      title: 'Cài Đặt Lại Hệ Điều Hành',
      description: 'Cài đặt lại hệ điều hành tự động và nhanh chóng. Hỗ trợ đủ os: windows và linux.'
    }
  ];

  const faqGeneral = [
    {
      question: 'Cloud VPS khác VPS ở điểm nào?',
      answer: 'Cloud VPS là máy chủ đám mây, điểm nổi bật nhất của Clous VPS là không bị giới hạn về dung lượng, có thể dễ dàng nâng cấp trong vài phút. Đặc biệt dữ liệu sẽ luôn được lưu trự trên nhiều máy chủ đảm bảo tính ổn định và bảo mật. Tất cả VPS Việt Nam tại VMon Cloud đều là Cloud VPS.'
    },
    {
      question: 'Tôi có thể cài hệ điều hành nào cho VPS?',
      answer: 'Trong khi nhiều nhà cung cấp chỉ hỗ trợ một số hệ điều hành cơ bản cho các cấu hình, tại VMon Cloud, tất cả các cấu hình, từ nhỏ đến lớn, đều được hỗ trợ bởi một loạt các hệ điều hành đa dạng, đáp ứng mọi nhu cầu của người sử dụng. Từ các phiên bản Windows như Windows 10, Windows Server 2012r2, 2016, 2019, 2022. Bên cạnh đó, còn có CentOS và Ubuntu Server, Alma Linux, Rocky Linux đáp ứng mọi nhu cầu sử dụng của bạn.'
    },
    {
      question: 'VPS IP chung hay riêng?',
      answer: 'Mỗi VPS ở VMon Cloud đều có địa chỉ IP riêng biệt, bất kể là VPS Việt Nam hay VPS nước ngoài.'
    },
    {
      question: 'Dữ liệu của tôi trong VPS có được bảo mật không?',
      answer: 'Quý khách hoàn toàn yên tâm, bảo mật thông tin của khách hàng và những dữ liệu khách hàng là trách nhiệm của VMon Cloud. Điều này được thể hiện chi tiết ở Điều khoản sử dụng.'
    },
    {
      question: 'Tôi đang phân vân không biết nên lựa chọn VPS từ quốc gia nào và cấu hình nào để phù hợp với nhu cầu sử dụng?',
      answer: 'Để chọn quốc gia, bạn cần xác định mục đích sử dụng VPS hoặc vị trí địa lý khách hàng của bạn. Nếu khách hàng của bạn ở trong nước, lựa chọn VPS Việt Nam có thể giúp giảm thiểu độ trễ và tăng tốc độ truy cập; nếu ở nước ngoài, VMon Cloud cung cấp các lựa chọn VPS Mỹ, VPS Anh, và VPS Singapore. Đối với việc chọn cấu hình, nếu bạn đang phân vân, hãy bắt đầu bằng cấu hình tối thiểu mà bạn muốn. Sau khi trải nghiệm thực tế, nếu cần thêm tài nguyên như RAM, CPU, hoặc ổ cứng, bạn có thể nâng cấp một cách tự động chỉ sau vài thao tác.'
    },
    {
      question: 'Tôi có thể liên hệ với VMon Cloud thế nào?',
      answer: 'VMon Cloud hỗ trợ bạn qua nhiều kênh khác nhau, bạn có thể liên hệ với chúng tôi qua fanpage, zalo, telegram, hotline. Đặc biệt, để liên hệ trực tiếp với bộ phận kỹ thuật, bạn có thể gửi ticket để được hỗ trợ nhanh nhất.'
    },
    {
      question: 'VPS có gia hạn được không?',
      answer: 'Dĩ nhiên, ở VMon Cloud, bạn có thể gia hạn VPS theo từng tháng hoặc năm. Gia hạn lâu dài sẽ mang lại nhiều ưu đãi hấp dẫn hơn cho bạn.'
    }
  ];

  const faqUsage = [
    {
      question: 'Tôi mới sử dụng VPS, VMon Cloud hỗ trợ tôi thế nào?',
      answer: 'Bạn đừng lo, nếu bạn là người mới sử dụng, hãy liên hệ trực tiếp với chúng tôi, VMon luôn sẵn sàng hỗ trợ bạn bất kỳ lúc nào. Đặc biệt, chúng tôi đã biên soạn sẵn những bài biết, clip hướng dẫn. Bạn có thể tham khảo bài viết: Hướng Dẫn Sử Dụng VPS Windows.'
    },
    {
      question: 'Tôi có thể nâng cấp VPS của mình không? Nâng cấu hình dữ liệu trong VPS còn hay mất?',
      answer: 'Đương nhiên rồi, khi nhu cầu sử dụng của bạn tăng lên, tài nguyên VPS hiện tại không đủ, bạn có thể nâng cấp VPS của mình chỉ với vài click chuột tại trang quản lý của VMon Cloud. Số tiền và thời gian sử dụng tương ứng sẽ được tính toán tự động bởi hệ thống và thông báo cho bạn. Bạn có thể tham khảo bài viết: Hướng dẫn nâng cấp cấu hình VPS.'
    },
    {
      question: 'Nâng cấu hình dữ liệu trong VPS còn hay mất?',
      answer: 'Bạn hoàn toàn yên tâm, khi nâng cấp cấu hình VPS, mọi dữ liệu của bạn vẫn còn nguyên vẹn. Đồng thời, VMon Cloud định kỳ sao lưu hàng tuần hoàn toàn miễn phí, đảm bảo an toàn tuyệt đối cho dữ liệu của bạn.'
    },
    {
      question: 'Tôi gia hạn VPS trước thời gian hết hạn có được không?',
      answer: 'Tất nhiên là CÓ. Bạn có thể gia hạn bất kỳ khi nào bạn muốn.'
    },
    {
      question: 'Làm sao để biết VPS của tôi sắp hết hạn?',
      answer: 'VMon Cloud có hệ thống email thông báo khi VPS của bạn sắp hết hạn. Chúng tôi sẽ gửi email nhắc nhở trước 3 ngày, và bạn sẽ nhận được tổng cộng 3 lần nhắc nhở. Để đảm bảo sự thuận tiện, bạn cũng có thể nạp trước tiền vào tài khoản tại VMon. Khi đến hạn thanh toán, VPS sẽ tự động được gia hạn.'
    },
    {
      question: 'Tôi muốn đổi gói VPS có được không?',
      answer: 'Hoàn toàn có thể. Ví dụ, bạn đang sử dụng VPS Việt Nam và muốn chuyển sang VPS Mỹ, VMon sẽ linh hoạt hỗ trợ bạn trong việc chuyển đổi gói dịch vụ, đồng thời đảm bảo rằng dữ liệu của bạn sẽ được giữ nguyên.'
    },
    {
      question: 'Tôi có thể xem Password VPS Việt Nam của mình ở đâu?',
      answer: 'Khi bạn đã mua và hoàn tất việc thanh toán, sau khoảng từ 3 đến 5 phút, hệ thống sẽ tự động gửi thông tin VPS về email mà bạn đã đăng ký với VMon Cloud. Hoặc bạn có thể xem mật khẩu VPS của mình ở trang quản lý.'
    }
  ];

  const faqPayment = [
    {
      question: 'VMon Cloud hỗ trợ các phương thức thanh toán nào?',
      answer: 'Hiện tại, VMon Cloud chấp nhận thanh toán qua chuyển khoản ngân hàng và Paypal. Ngay sau khi bạn thanh toán dịch vụ, hệ thống sẽ tự động gửi thông tin đầy đủ của dịch vụ bạn đã đăng ký đến địa chỉ email mà bạn đã cung cấp khi đăng ký với VMon Cloud. Quá trình này chỉ mất khoảng 3 phút.'
    },
    {
      question: 'Khi thanh toán, tôi quên không ghi nội dung chuyển tiền, tôi phải làm sao?',
      answer: 'Khi bạn mua VPS, hệ thống sẽ hiển thị mã QR code chứa đầy đủ thông tin về số tiền cần chuyển và nội dung giao dịch. Bạn chỉ cần quét mã QR code để thanh toán hóa đơn tự động. Trong trường hợp bạn không thể quét mã QR code, bạn có thể thực hiện giao dịch bằng cách ghi đúng nội dung theo định dạng mà hệ thống hướng dẫn. Nếu bạn quên không ghi nội dung chuyển tiền, hãy liên hệ với VMon Cloud để nhận sự hỗ trợ nhanh chóng nhất.'
    },
    {
      question: 'Chính sách hoàn tiền của VMon Cloud thế nào?',
      answer: 'VMon Cloud cam kết hỗ trợ hoàn tiền trong khoảng thời gian từ 3 đến 5 ngày làm việc. Trong 7 ngày đầu sử dụng dịch vụ, nếu bạn không hài lòng với bất kỳ lý do nào, bạn có thể yêu cầu hoàn tiền và chúng tôi sẽ hoàn lại 100% số tiền cho bạn. Trong quá trình sử dụng tiếp theo, nếu xuất hiện lỗi do chất lượng dịch vụ giảm sút và không đảm bảo, VMon Cloud sẽ hoàn lại số tiền tương ứng sau khi đã trừ đi chi phí dịch vụ đã sử dụng theo số ngày.'
    }
  ];

  const otherVPSServices = [
    {
      title: 'VPS US - Mỹ',
      link: '/vps-us',
      flag: getStorageUrl('flag/usa-flag.svg'),
      features: [
        'Ưu đãi hấp dẫn',
        'Backup thường xuyên',
        'Tốc độ mạng cực nhanh',
        'Ổ cứng NVMe'
      ]
    },
    {
      title: 'VPS EU - Châu Âu',
      link: '/vps-europe',
      flag: getStorageUrl('/flag/eu-flag.svg'),
      features: [
        'Thời gian khởi tạo nhanh',
        'Dùng thử miễn phí trong 7 ngày',
        'Miễn phí DDos',
        'Kích hoạt dễ dàng'
      ]
    },
    {
      title: 'VPS Singapore',
      link: '/vps-singapore',
      flag: getStorageUrl('/flag/singapore-flag.svg'),
      features: [
        'Giá chỉ từ 125.000đ/tháng',
        'Tốc độ xử lý cao',
        'Khởi tạo nhanh chỉ với 10 phút',
        'Dùng thử miễn phí'
      ]
    },
    {
      title: 'VPS Canada',
      link: '/vps-canada',
      flag: getStorageUrl('/flag/canada-flag.svg'),
      features: [
        'Sao lưu tự động',
        'Có khả năng mở rộng',
        'Hỗ trợ đa dạng hệ điều hành',
        'Miễn phí dùng thử'
      ]
    },
    {
      title: 'VPS Australia',
      link: '/vps-australia',
      flag: getStorageUrl('/flag/australia-flag.svg'),
      features: [
        'Trình quản lý vô cùng thân thiện',
        'Sao lưu dữ liệu định kỳ',
        'Dễ dàng nâng cấp',
        'Khả năng truy cập từ xa hiệu quả'
      ]
    },
    {
      title: 'VPS WINDOWS',
      link: '/vps-windows',
      flag: getStorageUrl('/flag/windows.svg'),
      features: [
        'Hiệu suất vượt trội',
        'Băng thông luôn ổn định',
        'Có mặt khắp nơi trên thế giới'
      ]
    }
  ];

  const nextFeedbackSlide = () => {
    setCurrentFeedbackSlide((prev) => (prev + 1) % feedbackImages.length);
  };

  const prevFeedbackSlide = () => {
    setCurrentFeedbackSlide((prev) => (prev - 1 + feedbackImages.length) % feedbackImages.length);
  };

  const nextGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">VPS Việt Nam</h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Thuê VPS Việt Nam với phần cứng mạnh mẽ và băng thông lên đến 1Gbps, kích hoạt đơn giản. Tìm hiểu ngay để có giá chỉ từ 115.000đ/tháng.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">BẢNG GIÁ CLOUD VPS Việt Nam</h2>
          </div>

          {/* Alert */}
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-8 rounded">
            <p className="font-bold">Ưu đãi hấp dẫn giảm ngay 40% khi gia hạn 3 năm.</p>
            <p>Giảm 20% khi gia hạn 1 năm, giảm 10% khi gia hạn 6 tháng, giảm 5% khi gia hạn 3 tháng.</p>
          </div>

          {/* Tabs - Centered */}
          <div className="mb-8 flex justify-center">
            <div className="border-b border-gray-200 inline-block">
              <nav className="-mb-px flex">
                <button
                  onClick={() => setActiveTab('nvme')}
                  className={`${
                    activeTab === 'nvme'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  } whitespace-nowrap py-4 px-6 border-b-2 font-medium text-lg`}
                >
                  Cloud VPS NVME
                </button>
                <button
                  onClick={() => setActiveTab('platinum')}
                  className={`${
                    activeTab === 'platinum'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  } whitespace-nowrap py-4 px-6 border-b-2 font-medium text-lg`}
                >
                  Cloud VPS Platinum
                </button>
              </nav>
            </div>
          </div>

          {/* Mobile Pricing Cards */}
          <div className="block md:hidden">
            <div className="space-y-4">
              {(activeTab === 'nvme' ? nvmePlans : platinumPlans).map((plan, index) => (
                <div key={index} className={`bg-white rounded-lg shadow-lg border-2 p-4 ${plan.popular ? 'border-blue-500' : 'border-gray-200'}`}>
                  {plan.popular && (
                    <div className="bg-blue-500 text-white text-center py-1 px-3 rounded-full text-sm font-semibold mb-3 inline-block">
                      Phổ biến nhất
                    </div>
                  )}
                  
                  <div className="text-center mb-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{plan.name}</h3>
                    <div className="mb-2">
                      <span className="text-2xl font-bold text-blue-600">{plan.price}</span>
                      <span className="text-gray-600 ml-1">VNĐ/tháng</span>
                    </div>
                    <div className="text-sm text-gray-500 line-through">{plan.originalPrice}VNĐ</div>
                  </div>

                  <div className="grid grid-cols-2 gap-3 mb-4 text-sm">
                    <div className="bg-gray-50 p-2 rounded">
                      <span className="text-gray-600">CPU:</span>
                      <div className="font-semibold">{plan.cpu}</div>
                    </div>
                    <div className="bg-gray-50 p-2 rounded">
                      <span className="text-gray-600">RAM:</span>
                      <div className="font-semibold">{plan.ram}</div>
                    </div>
                    <div className="bg-gray-50 p-2 rounded">
                      <span className="text-gray-600">Storage:</span>
                      <div className="font-semibold">{plan.storage}</div>
                    </div>
                    <div className="bg-gray-50 p-2 rounded">
                      <span className="text-gray-600">Bandwidth:</span>
                      <div className="font-semibold">{plan.bandwidth}</div>
                    </div>
                  </div>

                  <div className="text-center">
                    <a
                      href="https://cloud.vmon.vn/cart/vps-vn-nvme/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors inline-block font-semibold"
                    >
                      Đăng Ký
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Desktop Pricing Table */}
          <div className="hidden md:block overflow-x-auto">
            <div className="min-w-full">
              <div className="grid grid-cols-1 gap-4">
                {/* Header Row */}
                <div className="grid grid-cols-6 gap-2 bg-gray-50 p-4 rounded-lg font-medium text-gray-700 text-sm">
                  <div>CPU Cores</div>
                  <div>RAM</div>
                  <div>Ổ Cứng</div>
                  <div>Băng Thông</div>
                  <div>Giá (Tháng)</div>
                  <div></div>
                </div>
                
                {/* Data Rows */}
                {(activeTab === 'nvme' ? nvmePlans : platinumPlans).map((plan, index) => (
                  <div key={index} className={`grid grid-cols-6 gap-2 p-4 border rounded-lg ${plan.popular ? 'bg-blue-50 border-blue-200' : 'bg-white border-gray-200'}`}>
                    <div className="text-sm text-gray-900">{plan.cpu}</div>
                    <div className="text-sm text-gray-900">{plan.ram}</div>
                    <div className="text-sm text-gray-900">{plan.storage}</div>
                    <div className="text-sm text-gray-900">{plan.bandwidth}</div>
                    <div className="text-sm font-medium text-gray-900">{plan.price} VNĐ</div>
                    <div className="text-right">
                      <a
                        href="https://cloud.vmon.vn/cart/vps-vn-nvme/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm transition-colors"
                      >
                        Đăng Ký
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Additional Pricing - Compact Layout */}
          <div className="mt-12">
            <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center">Bảng Giá Đăng Ký Thêm CPU, RAM, Ổ Cứng, IP</h3>
            <div className="bg-white rounded-lg shadow overflow-hidden max-w-2xl mx-auto">
              <div className="divide-y divide-gray-200">
                {additionalPricing.map((item, index) => (
                  <div key={index} className="px-6 py-3 flex items-center justify-between">
                    <div className="flex items-center">
                      <CheckCircle className="h-4 w-4 text-green-500 mr-3 flex-shrink-0" />
                      <span className="text-gray-900 font-medium">{item.item}</span>
                    </div>
                    <span className="text-gray-600 font-semibold">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Bạn có muốn đảm bảo VPS của mình hoạt động ổn định?</h3>
              <p className="text-gray-600 mb-8">
                Hãy chọn Cloud VPS - giải pháp tối ưu cho tính ổn định và độ tin cậy cao. Với cơ sở hạ tầng phân tán và quản lý chuyên nghiệp, bạn có thể yên tâm rằng dịch vụ của bạn sẽ luôn hoạt động một cách trơn tru và không gián đoạn.
              </p>

              <h3 className="text-2xl font-bold text-gray-900 mb-6">Bạn có lo lắng về an toàn dữ liệu trên VPS của mình?</h3>
              <p className="text-gray-600">
                Hãy chọn Cloud VPS - giải pháp đáng tin cậy với việc lưu trữ dữ liệu trên nhiều máy chủ. Với tính linh hoạt và độ bảo mật cao, bạn có thể yên tâm rằng dữ liệu của bạn luôn an toàn và không bao giờ mất mát.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Dễ dàng lựa chọn gói VPS phù hợp với nhu cầu của bạn với bảng so sánh dịch vụ của VMon Cloud</h3>
              
              <div className="overflow-x-auto">
                <div className="min-w-full">
                  <div className="grid grid-cols-1 gap-2">
                    {/* Header */}
                    <div className="grid grid-cols-3 gap-2 bg-gray-50 p-3 rounded-lg font-medium text-gray-700 text-sm">
                      <div></div>
                      <div className="text-center">Cloud VPS NVMe</div>
                      <div className="text-center">Cloud VPS Platinum</div>
                    </div>
                    
                    {/* Rows */}
                    {comparisonTable.map((row, index) => (
                      <div key={index} className="grid grid-cols-3 gap-2 p-3 border-b border-gray-200">
                        <div className="text-sm text-gray-900">{row.feature}</div>
                        <div className="text-center">
                          {row.nvme ? (
                            <CheckCircle className="h-5 w-5 text-green-500 mx-auto" />
                          ) : (
                            <div className="h-5 w-5 text-red-500 flex items-center justify-center mx-auto">✕</div>
                          )}
                        </div>
                        <div className="text-center">
                          {row.platinum ? (
                            <CheckCircle className="h-5 w-5 text-green-500 mx-auto" />
                          ) : (
                            <div className="h-5 w-5 text-red-500 flex items-center justify-center mx-auto">✕</div>
                          )}
                        </div>
                      </div>
                    ))}
                    
                    {/* Action Row */}
                    <div className="grid grid-cols-3 gap-2 p-3">
                      <div></div>
                      <div className="text-center">
                        <a
                          href="https://cloud.vmon.vn/cart/vps-vn-nvme/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors inline-block text-sm"
                        >
                          Đăng Ký
                        </a>
                      </div>
                      <div className="text-center">
                        <a
                          href="#"
                          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors inline-block text-sm"
                        >
                          Đăng Ký
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OS Support Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Các hệ điều hành VMon Cloud hỗ trợ khi mua VPS</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {operatingSystems.map((os, index) => (
              <div 
                key={index} 
                className="relative bg-white rounded-lg shadow p-6 text-center hover:shadow-lg transition-all duration-300 cursor-pointer overflow-hidden group"
              >
                {/* Overlay effect */}
                <div className="absolute inset-0 bg-blue-600 bg-opacity-90 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out flex items-center justify-center">
                  <span className="text-white font-semibold text-lg">{os.name}</span>
                </div>
                
                {/* Content */}
                <img
                  src={os.logo}
                  alt={os.name}
                  className="w-16 h-16 mx-auto mb-4 object-contain"
                />
                <h3 className="text-lg font-semibold text-gray-900">{os.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">TẠI SAO NÊN THUÊ VPS VIỆT NAM TẠI VMON CLOUD?</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow">
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                    <benefit.icon className="h-8 w-8 text-blue-600" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">{benefit.title}</h3>
                <p className="text-gray-600 text-center">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">KHÁCH HÀNG NÓI GÌ VỀ CHÚNG TÔI?</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-4xl mx-auto">
            Tại VMon Cloud, ý kiến của khách hàng được đặt lên hàng đầu và chúng tôi luôn sẵn sàng lắng nghe và tiếp thu phản hồi để không ngừng cải thiện chất lượng sản phẩm và dịch vụ. Điều này giúp chúng tôi đáp ứng tốt hơn nhu cầu và mong muốn của khách hàng một cách tối đa.
          </p>
          
          {/* Feedback Slider */}
          <div className="relative max-w-4xl mx-auto">
            <div className="overflow-hidden rounded-lg">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentFeedbackSlide * 100}%)` }}
              >
                {feedbackImages.map((image, index) => (
                  <div key={index} className="w-full flex-shrink-0">
                    <img
                      src={image}
                      alt={`Feedback ${index + 1}`}
                      className="w-full h-96 object-contain bg-gray-100 rounded-lg"
                    />
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation Buttons */}
            <button
              onClick={prevFeedbackSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronLeft className="h-6 w-6 text-gray-600" />
            </button>
            <button
              onClick={nextFeedbackSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronRight className="h-6 w-6 text-gray-600" />
            </button>
            
            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {feedbackImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentFeedbackSlide(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    index === currentFeedbackSlide ? 'bg-blue-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Lợi Ích khi Mua VPS Tại VMon Cloud</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow">
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                    <advantage.icon className="h-8 w-8 text-blue-600" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">{advantage.title}</h3>
                <p className="text-gray-600 text-center">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Thư Viện Hình Ảnh</h2>
          <p className="text-lg text-gray-600 mb-12 text-center">
            Quản lý tài khoản, tạo mới và giám sát khi Thuê VPS Việt Nam dễ dàng với trang panel hiện đại, thân thiện dễ sử dụng.
          </p>
          
          {/* Gallery Slider */}
          <div className="relative max-w-4xl mx-auto">
            <div className="overflow-hidden rounded-lg bg-gray-100">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentGallerySlide * 100}%)` }}
              >
                {galleryImages.map((image, index) => (
                  <div key={index} className="w-full flex-shrink-0 p-8">
                    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                      <img
                        src={image.src}
                        alt={image.title}
                        className="w-full h-64 object-contain bg-gray-50"
                      />
                      <div className="p-6 text-center">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{image.title}</h3>
                        <p className="text-gray-600">{image.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation Buttons */}
            <button
              onClick={prevGallerySlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronLeft className="h-6 w-6 text-gray-600" />
            </button>
            <button
              onClick={nextGallerySlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronRight className="h-6 w-6 text-gray-600" />
            </button>
            
            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentGallerySlide(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    index === currentGallerySlide ? 'bg-blue-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Những câu hỏi thường gặp khi thuê VPS Việt Nam</h2>
          
          <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
            <div className="mb-6">
              <div className="border-b border-gray-200">
                <nav className="-mb-px flex flex-wrap">
                  <button
                    onClick={() => setActiveTab('general')}
                    className={`${
                      activeTab === 'general'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    } whitespace-nowrap py-4 px-4 md:px-6 border-b-2 font-medium text-sm md:text-lg`}
                  >
                    Câu hỏi chung
                  </button>
                  <button
                    onClick={() => setActiveTab('usage')}
                    className={`${
                      activeTab === 'usage'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    } whitespace-nowrap py-4 px-4 md:px-6 border-b-2 font-medium text-sm md:text-lg`}
                  >
                    Sử dụng VPS
                  </button>
                  <button
                    onClick={() => setActiveTab('payment')}
                    className={`${
                      activeTab === 'payment'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    } whitespace-nowrap py-4 px-4 md:px-6 border-b-2 font-medium text-sm md:text-lg`}
                  >
                    Thanh toán và hoàn tiền
                  </button>
                </nav>
              </div>
            </div>

            <div className="space-y-4">
              {(activeTab === 'general' ? faqGeneral : 
                activeTab === 'usage' ? faqUsage : 
                faqPayment).map((faq, index) => (
                <details key={index} className="group bg-gray-50 rounded-lg">
                  <summary className="flex justify-between items-center font-medium cursor-pointer p-4">
                    <span className="text-gray-900 text-sm md:text-base">{faq.question}</span>
                    <span className="transition group-open:rotate-180">
                      <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24">
                        <path d="M6 9l6 6 6-6"></path>
                      </svg>
                    </span>
                  </summary>
                  <p className="text-gray-600 p-4 pt-0 text-sm md:text-base">{faq.answer}</p>
                </details>
              ))}
            </div>
          </div>

          {/* Social Share */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Chia Sẻ Lên Mạng Xã Hội</h3>
            <div className="flex justify-center space-x-4">
              <a href="#" className="text-blue-600 hover:text-blue-800">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"></path>
                </svg>
              </a>
              <a href="#" className="text-red-600 hover:text-red-800">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"></path>
                </svg>
              </a>
              <a href="#" className="text-blue-400 hover:text-blue-600">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                </svg>
              </a>
              <a href="#" className="text-blue-800 hover:text-blue-900">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd"></path>
                </svg>
              </a>
              <a href="#" className="text-blue-500 hover:text-blue-700">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Other Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Các Dịch Vụ Khác Tại VMon Cloud</h2>
          <p className="text-lg text-gray-600 mb-12 text-center">
            Thuê VPS Giá rẻ - Lựa chọn lý tưởng cho máy chủ ảo với chi phí hợp lý. Môi trường độc lập, tài nguyên riêng biệt, linh hoạt và hiệu suất cao cho ứng dụng và trang web của bạn.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {otherVPSServices.map((service, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="p-6">
                  <div className="flex justify-center mb-4">
                    <img
                      src={service.flag}
                      alt={service.title}
                      className="w-16 h-12 object-contain"
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                    <Link to={service.link} className="hover:text-blue-600">
                      {service.title}
                    </Link>
                  </h3>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-gray-600">
                        <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-lg mb-4">Chúng tôi ở đây giúp các bạn có thể làm việc online một cách hiểu quả nhất.</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            Cùng nhau, Trực tuyến.
          </h2>
        </div>
      </section>
    </div>
  );
};

export default VPSVietnam;